import { Button as MButton, ButtonProps } from '@mui/material'

export const Button: React.FC<ButtonProps> = (props) => {
  return <MButton {...props} />
}
